import React, { useState } from "react";
import { useWebData } from "../../Context/webDataContext";
import { motion } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

function FAQs() {
  const { getFAQsData } = useWebData();
  const data = getFAQsData();
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="md:py-12 py-6" id="faqs">
      <div className="">
        <h2 className="text-2xl md:text-4xl px-12 font-bold text-[#08875D] text-center md:mb-20 mb-5">
          {data.mainTitle}
        </h2>
        <div className="space-y-4 lg:space-y-6">
          {data.items.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white p-4 border-b-[0.4px] transition-all"
              >
                <button
                  onClick={() => handleToggle(index)}
                  className="flex items-center justify-between w-full text-left focus:outline-none"
                >
                  <span className="text-base lg:text-xl font-manrope font-bold text-[#000000]">
                    {faq.question}
                  </span>
                  {isOpen ? (
                    <ChevronUp size={16} className="w-12 h-5 primary-text" />
                  ) : (
                    <ChevronDown size={16} className="w-12 h-5 primary-text" />
                  )}
                </button>
                {isOpen && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className="mt-4 text-base lg:text-xl font-normal leading-relaxed text-[#000000]"
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQs;
